
  import {prepareImageUrl} from '@/helper/ImageHelper';
  export default {
    name: 'SectionHeadlineWithTextAndImage',
    components: {
      RichText: () => import('@/components/elements/RichText'),
    },
    props: {
      section: {
        type: Object,
        required: false,
        default: () => {},
      },
    },
    serverCacheKey: function (props) {
      return 'section-headline-with-text-and-image-' + props.section.id;
    },
    data() {
      return {
        imageUrl: '',
        sizeOfImageColumn: 0,
      };
    },
    computed: {
      customWidth() {
        const percentage = (this.sizeOfImageColumn / 12) * 100;
        return this.$vuetify.breakpoint.width <=
          this.$vuetify.breakpoint.thresholds.sm
          ? '100%'
          : percentage + '%';
      },
    },
    created() {
      this.imageUrl = this.section.image
        ? prepareImageUrl(this.section.image.url)
        : '';
      this.sizeOfImageColumn = this.section.image_width
        ? Number(this.section.image_width.split('_')[1])
        : 6;
    },
  };
